/**
 * Internal/operator email addresses that should NEVER produce PostHog events,
 * `UserEvent` rows, or session recordings.
 *
 * Reasons we want them out:
 *  - Support replies / debugging from `support@formsuite.co` muddy real-user
 *    funnels and retention curves.
 *  - Founders / employees logging in for QA inflate activation metrics.
 *
 * Add new addresses here (lowercased) — the helpers below are the single
 * source of truth, used by both the browser and server tracking pipelines.
 *
 * Companion path-based exclusion lives in `client.ts` (admin routes).
 */
export const EXCLUDED_TRACKING_EMAILS: readonly string[] = [
  'support@formsuite.co',
];

/**
 * `true` when the given email belongs to an internal/operator account that
 * should be excluded from analytics. Case-insensitive, null-safe.
 */
export function isExcludedTrackingEmail(email?: string | null): boolean {
  if (!email) return false;
  return EXCLUDED_TRACKING_EMAILS.includes(email.trim().toLowerCase());
}
